(function ($) {
    $.fn.FieldCopyValue = function (options) {
        var settings = $.extend({
            'target' : '',
            'trigger-change' : true,
        }, options);
        $('body').on('change','#'+$(this).attr('id'), function (e){
            if (!settings['trigger-change']){
                $(e.currentTarget).data('copy-no-trigger', true);
            }
            var $field = $(settings['target']);
            //specific
            switch (settings['target']) {
                case '#header_etatvente' :
                    $field.empty();
                    break;
                case '#header_vendeur':
                    var both = $(this).find('option:selected').text().split('(');
                    var name = both.shift();
                    name = name.substr(0,name.length - 1);
                    var code =both.pop();
                    code = code.substr(0,code.length - 1);
                    $field.html(
                        '<a href="javascript:openForm(\'OCRD\', \''+code+'\')" class="text-dark">\n' +
                            name +
                        '</a>\n');
                    break;
                case '#vehicle_folder_vehicleQuotation_etat' :
                    // $field.val($(this).val());
                    $field.val($(this).val().replace(/(?:\r\n|\r|\n)/g, ' '));
                    break;
                default :
                    //standard
                    if($field.prop('tagName') === 'DIV') {
                        if($(this).prop('tagName') === 'SELECT'){
                            $field.html($(this).find('option:selected').text());
                        } else {
                            $field.html($(this).val());
                        }
                    } else {
                        if($field.attr('type') === 'checkbox') {
                            $field.prop('checked', !!$(this).prop('checked'));
                        }
                        $field.val($(this).val());
                    }
                    if ($field.data('copy-no-trigger') !== undefined){
                        $field.removeData('copy-no-trigger');
                    } else {
                        $field.change();
                    }
            }
        });
    };
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/fieldCopyValue.js